import { useContext } from "react";
import { BaseInputAdornmentContext } from "./BaseInputAdornmentContext.tsx";

export const useBaseInputAdornmentContext = () => {
  const context = useContext(BaseInputAdornmentContext);
  if (!context) {
    throw new Error(
      "useBaseInputAdornmentContext must be used within BaseInputAdornmentContext.Provider",
    );
  }
  return context;
};
